module.exports = __webpack_public_path__ + "img/minus_btn.3339fb57.png";